import { Button } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import { ICustomTheme } from 'interfaces';
import { StyledFieldError } from '../../../styles';

/** Scale/slider row */
export const StyledScaleRow = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),
  }),
);

/** Base scale button — selected state is handled via className in the component */
export const StyledScaleButton = styled(Button)(
  ({ theme }: { theme: ICustomTheme }) => ({
    minWidth: 40,
    width: 40,
    height: 40,
    borderRadius: '50%',
    padding: 0,
    fontWeight: theme.typography.fontWeightBold as number,
    fontSize: theme.typography.body2.fontSize,
    backgroundColor: 'transparent',
    color: theme.colors.paletteFromBO.main,
    border: `2px solid ${theme.colors.paletteFromBO.main}`,
    '&:hover': {
      backgroundColor: `${theme.colors.paletteFromBO.main}20`,
    },
    '&.selected': {
      backgroundColor: theme.colors.paletteFromBO.main,
      color: theme.colors.white,
      '&:hover': {
        filter: 'brightness(0.9)',
      },
    },
  }),
);

/** Min/max labels row above the scale buttons */
export const StyledScaleLabelsRow = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 4,
}));

/** Field error below the scale — overrides the base top margin */
export const StyledScaleFieldError = styled(StyledFieldError)(
  ({ theme }: { theme: ICustomTheme }) => ({
    marginTop: theme.spacing(1),
  }),
);
